<template>
  <v-dialog v-model="dialog" persistent max-width="80%">
    <v-card>
      <v-card-text class="text-md-center">

        <ItemCheckList v-if="itemId > 0" :item-id="itemId" :item-type="itemType" :cases-id="casesId"></ItemCheckList>
        <!--<ItemCheckList v-if="itemId > 0" :item-id="itemId" :item-type="itemType" :cases-id="casesId"></ItemCheckList>-->

      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat block @click.stop="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ItemCheckList from '@/components/ItemCheckList'

  export default {
    components: { ItemCheckList },
    mixins: [ itemTypesMixins ],
    methods: {
      closeDialog (event) {
        this.dialog = false

        this.$emit('update:itemId', 0)
      }
    },
    data () {
      return {
        dialog: false
      }
    },
    watch: {
      itemId () {
        if (this.itemId > 0) {
          this.dialog = true
        }
      }
    },
    props: {
      itemId: {
        type: Number,
        required: true
      },
      casesId: {
        default: 0,
        required: false
      },
      itemType: {
        type: Number,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditItemCheckListDialog.vue?3a548a8e